// The public website is plain HTML/CSS/JS in /public; this bundle only runs the content editor.
if (window.location.pathname.startsWith("/website-admin")) import("./admin/main");
